(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-in"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__featuredInMarqueeInit) return;
    window.__featuredInMarqueeInit = true;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function prefersReduced() {
      return prefersReducedMotion.matches;
    }

    function removeClones(track, group) {
      Array.prototype.slice.call(track.children).forEach(function (child) {
        if (child !== group) child.remove();
      });
    }

    function createClone(group) {
      var clone = group.cloneNode(true);
      clone.removeAttribute('data-featured-in-group');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a').forEach(function (link) {
        link.setAttribute('tabindex', '-1');
      });
      return clone;
    }

    function measure(marquee) {
      var track = marquee.querySelector('[data-featured-in-track]');
      var group = marquee.querySelector('[data-featured-in-group]');
      if (!track || !group) return;

      var groupWidth = group.scrollWidth;
      var containerWidth = marquee.clientWidth;
      var needsScroll = !prefersReduced() && groupWidth > containerWidth + 1;

      if (!needsScroll) {
        removeClones(track, group);
        marquee.classList.remove('is-scrolling');
        marquee.classList.add('is-static');
        marquee.style.removeProperty('--featured-in-scroll-duration');
        return;
      }

      if (track.children.length === 1) {
        track.appendChild(createClone(group));
      }

      var speed = parseFloat(marquee.getAttribute('data-scroll-speed')) || 40;
      var duration = Math.max(groupWidth / speed, 8);

      marquee.style.setProperty('--featured-in-scroll-duration', duration + 's');
      marquee.classList.remove('is-static');
      marquee.classList.add('is-scrolling');
    }

    function bindImages(marquee) {
      marquee.querySelectorAll('img').forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', function () {
          measure(marquee);
        }, { once: true });
      });
    }

    function initMarquee(marquee) {
      if (!marquee) return;

      if (marquee._featuredInCleanup) {
        marquee._featuredInCleanup();
      }

      bindImages(marquee);
      measure(marquee);

      var resizeObserver = new ResizeObserver(function () {
        measure(marquee);
      });
      resizeObserver.observe(marquee);

      var motionHandler = function () {
        measure(marquee);
      };
      if (prefersReducedMotion.addEventListener) {
        prefersReducedMotion.addEventListener('change', motionHandler);
      } else if (prefersReducedMotion.addListener) {
        prefersReducedMotion.addListener(motionHandler);
      }

      marquee._featuredInCleanup = function () {
        resizeObserver.disconnect();
        if (prefersReducedMotion.removeEventListener) {
          prefersReducedMotion.removeEventListener('change', motionHandler);
        } else if (prefersReducedMotion.removeListener) {
          prefersReducedMotion.removeListener(motionHandler);
        }
      };
    }

    function initAll(root) {
      var scope = root || document;
      scope.querySelectorAll('[data-featured-in-marquee]').forEach(initMarquee);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-featured-in-marquee]').forEach(function (marquee) {
        if (marquee._featuredInCleanup) marquee._featuredInCleanup();
      });
    });

    document.addEventListener('shopify:section:reorder', function () {
      initAll();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
